export interface ElasticQueryResult {
  [key: string]: ElasticQueryResultItem;
}

export type ElasticQueryResultComplete = {
  contractId: number;
} & ElasticQueryResult[];

export interface ElasticQueryResultItem {
  value: any;
  transId?: string;
}

export interface ElasticQuerySearch {
  reportName?: string;
  beginDate: string;
  endDate: string;
  data: DataCriterion[];
  filter?: FilterCriterion[];
  sort?: SortCriterion[];
}

export interface PaginatedSearchResponse {
  documents: ElasticQueryResult[];
  searchAfterString: string;
  hasMore: boolean;
  totalHits: number;
}

export interface PaginatedPreviewInput {
  result: any[];
  position: any;
  contractIds: number[];
  hasMore: boolean;
  searchAfterString: string;
  totalHits: number;
}

export interface FilterCriterion {
  field: string;
  type: string;
  groupType?: string;
  values: any[];
  operator: FilterCriterionOperator;
}

export interface DataCriterion {
  field: string;
  type: string;
  groupType?: string;
  transIds?: string[];
}

export interface SortCriterion {
  field: string;
  type: string;
  order: string;
}

export enum FilterCriterionOperator {
  EQ = 'EQ',
  NE = 'NE',
  GT = 'GT',
  GTE = 'GTE',
  LT = 'LT',
  LTE = 'LTE',
  EM = 'EM',  // empty
  NEM = 'NEM', // not empty
  BEGINS_WITH = 'BEGINS_WITH',
  ENDS_WITH = 'ENDS_WITH',
  CONTAINS = 'CONTAINS',
  NOT_CONTAINS = 'NOT_CONTAINS',
}

export enum PayValueExtension {
  ALL = 'ALL',
  SUM = 'SUM',
  RETRO = 'RETRO'
}

export enum PayValueType {
  PAY_VALUE_ALL = 'PAY_VALUE_ALL',
  PAY_VALUE_SUM = 'PAY_VALUE_SUM',
  PAY_VALUE_RETRO = 'PAY_VALUE_RETRO',
}
